import { NODE_HEIGHT, NODE_WIDTH } from '../const';
import { colorPickerColors } from '../../common/color-picker/colorPickerColors';

export const SECTION_PADDING = 20;

export const SECTION_MIN_WIDTH = NODE_WIDTH + SECTION_PADDING;
export const SECTION_MIN_HEIGHT = NODE_HEIGHT + SECTION_PADDING;

export const SECTION_DEFAULT_COLOR = colorPickerColors.Grey300;
